import { Chip, SxProps, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { VendorActivationStatus } from 'entities/Vendors';
import { DynamicTooltip } from 'shared/ui/Tooltip';

import { STATUS_CONFIG } from '../lib/config/supplierStatusConfig';

interface SupplierStatusChipProps {
    status: VendorActivationStatus;
    sx?: SxProps<Theme>;
}

export const SupplierStatusChip = ({ status, sx }: SupplierStatusChipProps) => {
    const { t } = useTranslation();
    const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG];

    if (!config) return null;

    return (
        <DynamicTooltip
            placement="top"
            content={
                <Typography
                    variant="body2"
                    sx={{ lineHeight: 1.4, whiteSpace: 'pre-line' }}
                >
                    {t(config.tooltipBodyKey, config.tooltipBodyDefault)}
                </Typography>
            }
        >
            <Chip
                icon={config.icon}
                label={t(config.labelKey, config.labelDefault)}
                size="small"
                data-testclass="supplier-status-chip"
                sx={{
                    backgroundColor: config.backgroundColor,
                    color: config.color,
                    fontWeight: 700,
                    fontSize: '1rem',
                    borderRadius: '14px',
                    padding: '4px 4px',
                    cursor: 'pointer',
                    '& .MuiChip-label': { paddingRight: '8px' },
                    ...sx,
                }}
            />
        </DynamicTooltip>
    );
};
